import React, { useEffect } from "react";
import styled from "styled-components";
import { useTimeout } from "@sonder/ui/source/hooks/useTimeout";
import { Bell, X } from "@sonder/ui/source/icons";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { PrimaryButton } from "@sonder/ui/source/styled/fragments/PrimaryButton";
import { Toast } from "@sonder/ui/source/styled/fragments/Toast";
import { useSegment } from "analytics/segment";
import { FIFTEEN_SECONDS } from "core/constants";
import { useErrorReporterFiltered } from "core/hooks/useErrorReporterFiltered";
import { useUpdateTask } from "core/queries/UpdateTask";
import { removeUndo } from "tasks/actions";
import { useStore } from "tasks/store";

const Message = styled.span`
  margin: 0 1rem;
`;

export const UndoToast = () => {
  const { state, dispatch } = useStore();
  const { track } = useSegment();
  const errorReporter = useErrorReporterFiltered();
  const [onUpdateTask] = useUpdateTask({
    refetchQueries: ["GetTasks", "GetTask"],
  });

  // Wait 15 seconds before hiding the undo toast
  const taskId = state.undoComplete && state.undoComplete.taskId;
  const message = state.undoComplete && state.undoComplete.message;
  const { start } = useTimeout(
    () => taskId && dispatch(removeUndo(taskId)),
    FIFTEEN_SECONDS,
  );
  useEffect(() => {
    if (taskId) start();
  }, [taskId]);

  // Hide toast if there are no undos
  if (!taskId) return null;

  return (
    <Toast>
      <Bell />
      <Message>{message}</Message>
      <PrimaryButton
        title="Undo task completion"
        onClick={async () => {
          try {
            await onUpdateTask({ variables: { taskId, status: "ready" } });
            dispatch(removeUndo(taskId));
            track({
              eventName: "undo_toast",
              element: "undo_button",
              action: "click",
              props: { taskId },
            });
          } catch (error) {
            errorReporter.notify(error);
          }
        }}
      >
        Undo
      </PrimaryButton>
      <CircleButton
        backgroundVariant="dark"
        onClick={() => {
          dispatch(removeUndo(taskId));
          track({
            eventName: "undo_toast",
            element: "dismiss_button",
            action: "click",
            props: { taskId },
          });
        }}
      >
        <X />
      </CircleButton>
    </Toast>
  );
};
